import OrderDetails from './OrderDetails';

export {
  COURSE_ENTITLEMENT_PRODUCT_TYPE,
  ENROLLMENT_CODE_PRODUCT_TYPE,
  SEAT_PRODUCT_TYPE,
  VERIFIED_CERTIFICATE_TYPE,
  CREDIT_CERTIFICATE_TYPE,
} from './data/constants';

export default OrderDetails;
